import { ORDER_LIST_PREFIX as FEATURE_PREFIX } from 'featurePrefix.ids'

const HEADER_PREFIX = 'header'
const PAGINATION_NAVBAR_PREFIX = 'pagination-navbar'

export const HeaderIds = {
  ManageButton: `${FEATURE_PREFIX}__${HEADER_PREFIX}__manage-button`,
  ImportOrdersButton: `${FEATURE_PREFIX}__${HEADER_PREFIX}__import-orders`,
  ExcelOrdersButton: `${FEATURE_PREFIX}__${HEADER_PREFIX}__excel-orders`,
  StartOrderButton: `${FEATURE_PREFIX}__${HEADER_PREFIX}__start-order-button`,
  JoorPayTab: `${FEATURE_PREFIX}__${HEADER_PREFIX}__joor-pay-tab`,
  AllOrdersTab: `${FEATURE_PREFIX}__${HEADER_PREFIX}__all-orders-tab`,
  DivisionVisibility: `${FEATURE_PREFIX}__${HEADER_PREFIX}__division-visibility`,
} as const

export const PaginationNavbarIds = {
  DownloadConfirmationButton: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__download-confirmation-button`,
  ExportOrdersButton: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__export-button`,
  CancelStylesButton: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__cancel-styles-button`,
  ActionsButton: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__actions-button`,
  SendInvoiceOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__send-invoice-option`,
  ChangeSaleRepsOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__change-sale-reps-option`,
  ChangeStatusOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__change-status-option`,
  EditEventOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__edit-event-option`,
  ResendEmailsOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__resend-email-option`,
  UpdateOrderPricingOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__update-pricing-option`,
  SetToReExportOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__set-reexport-option`,
  MarkExportedOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__mark-exported-option`,
  ScheduledForExportOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__schedule-for-export-option`,
  DuplicateOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__duplicate-option`,
  MoveProductsOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__move-products-option`,
  AssignRetailerOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__assign-retailer-option`,
  RemoveStyleColorNoQuantitiesOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__remove-style-color-option`,
  SendToAssortmentOption: `${FEATURE_PREFIX}__${PAGINATION_NAVBAR_PREFIX}__send-to-assortment-option`,
} as const
